/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { BulkUpdateVisitsErrorDtoModel, BulkUpdateVisitsErrorDtoModelType } from "./BulkUpdateVisitsErrorDtoModel"
import { BulkUpdateVisitsErrorDtoModelSelector } from "./BulkUpdateVisitsErrorDtoModel.base"
import { VisitIdsDtoModel, VisitIdsDtoModelType } from "./VisitIdsDtoModel"
import { VisitIdsDtoModelSelector } from "./VisitIdsDtoModel.base"
import { RootStoreType } from "./index"


/**
 * BulkUpdateVisitsResultDtoBase
 * auto generated base class for the model BulkUpdateVisitsResultDtoModel.
 */
export const BulkUpdateVisitsResultDtoModelBase = ModelBase
  .named('BulkUpdateVisitsResultDto')
  .props({
    __typename: types.optional(types.literal("BulkUpdateVisitsResultDto"), "BulkUpdateVisitsResultDto"),
    success: types.union(types.undefined, types.array(types.late((): any => VisitIdsDtoModel))),
    totalSuccess: types.union(types.undefined, types.integer),
    error: types.union(types.undefined, types.array(types.late((): any => BulkUpdateVisitsErrorDtoModel))),
    totalError: types.union(types.undefined, types.integer),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class BulkUpdateVisitsResultDtoModelSelector extends QueryBuilder {
  get totalSuccess() { return this.__attr(`totalSuccess`) }
  get totalError() { return this.__attr(`totalError`) }
  success(builder: string | VisitIdsDtoModelSelector | ((selector: VisitIdsDtoModelSelector) => VisitIdsDtoModelSelector) | undefined) { return this.__child(`success`, VisitIdsDtoModelSelector, builder) }
  error(builder: string | BulkUpdateVisitsErrorDtoModelSelector | ((selector: BulkUpdateVisitsErrorDtoModelSelector) => BulkUpdateVisitsErrorDtoModelSelector) | undefined) { return this.__child(`error`, BulkUpdateVisitsErrorDtoModelSelector, builder) }
}
export function selectFromBulkUpdateVisitsResultDto() {
  return new BulkUpdateVisitsResultDtoModelSelector()
}

export const bulkUpdateVisitsResultDtoModelPrimitives = selectFromBulkUpdateVisitsResultDto().totalSuccess.totalError
